export const queryGetUserSignature = `
query User($userId: ID) {
  user(id: $userId) {
    signature
    id
    name
  }
}
`